import type { InputHTMLAttributes, Ref } from 'react';
import { cn } from '@/lib/cn';

export const inputClasses =
  'h-10 w-full rounded-control border border-input bg-card px-3 text-sm text-foreground placeholder:text-muted-foreground/80 transition-colors hover:border-foreground/50 focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-0 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70 aria-[invalid=true]:border-destructive aria-[invalid=true]:outline-destructive';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  ref?: Ref<HTMLInputElement>;
}

export function Input({ className, type = 'text', ref, ...props }: InputProps) {
  return <input ref={ref} type={type} className={cn(inputClasses, className)} {...props} />;
}
